import dynamic from 'next/dynamic'
import Image from 'next/image'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import LazyLoad from 'react-lazyload'
import AllFeaturesHeroSection from '~/components/LandingPage/AllFeaturesHeroSection'
import ContactRequestButton from '~/components/LandingPage/components/ContactRequestButton'
import FeatureBlock from '~/components/LandingPage/components/FeatureBlock/FeatureBlock'
import FeatureOverviewSection from '~/components/LandingPage/FeatureOverviewSection'
import LayoutLandingPage from '~/components/Layout/LayoutLandingPage'
import WhyDomainSection from '~/components/LandingPage/WhyDomainSection'

const LazyLoadWrapper = LazyLoad as unknown as FC<any>

const JourneySection = dynamic(
  () => import('~/components/LandingPage/JourneySection')
)

const AllFeaturesContainer: FC = () => {
  const { t } = useTranslation()

  return (
    <LayoutLandingPage>
      {/* Hero Banner */}
      <AllFeaturesHeroSection />

      {/* Features overview */}
      <LazyLoadWrapper height={500} once>
        <FeatureOverviewSection />
      </LazyLoadWrapper>

      {/* why do you need an ats */}
      <LazyLoadWrapper height={500} once>
        <FeatureBlock
          className="mt-[64px] mb-0 desktop:mt-[140px] desktop:mb-0"
          title={t('all_features:why_need_ats')}
          description={t('all_features:why_need_ats_description')}
          textPosition="left"
          openLink={<ContactRequestButton label={t('lp:see_more')} />}
          image={
            <picture>
              <source
                media="(min-width: 768px)"
                srcSet="/img/feature/lp/preview-interview-kit-desk.png"
              />
              <source
                media="(max-width: 767px)"
                srcSet="/img/feature/lp/preview-interview-kit-mweb.png"
              />
              <img alt="Preview interview kit" loading="lazy" />
            </picture>
          }
        />
      </LazyLoadWrapper>

      {/* benifits of ats */}
      <LazyLoadWrapper height={500} once>
        <FeatureBlock
          className="mt-[64px] mb-0 desktop:mt-[140px] desktop:mb-0"
          title={t('all_features:benifist_of_ats')}
          description={
            <div>
              {Array.from({ length: 5 }).map((_, index) => (
                <div
                  key={`benifits-of-ats-${index}`}
                  className="flex items-start gap-2">
                  <Image
                    src={`/img/feature/lp/check_circle.svg`}
                    loading="lazy"
                    width={20}
                    height={20}
                    quality={100}
                    alt="checked"
                    className="h-[20px] mt-1"
                  />
                  <span>{t(`all_features:benifist_of_ats_${index + 1}`)}</span>
                </div>
              ))}
            </div>
          }
          textPosition="right"
          image={
            <picture>
              <source
                media="(min-width: 768px)"
                srcSet="/img/feature/lp/benifits-of-ats-desk.png"
              />
              <source
                media="(max-width: 767px)"
                srcSet="/img/feature/lp/benifits-of-ats-mweb.png"
              />
              <img
                alt="Benefits of applicant tracking systems"
                loading="lazy"
              />
            </picture>
          }
        />
      </LazyLoadWrapper>

      <LazyLoadWrapper height={500} once>
        <WhyDomainSection />
      </LazyLoadWrapper>

      <LazyLoadWrapper height={300} once>
        <JourneySection className="desktop:mt-[140px] desktop:mb-[0px] bg-gray-50 mt-[64px] my-[0px] py-[64px]" />
      </LazyLoadWrapper>
    </LayoutLandingPage>
  )
}

export default AllFeaturesContainer
